import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import SunLifeInitiateProposalPage from './SunLife';
import DefaultInitiateProposalPage from './Default';
import AlliedInitiateProposalPage from './Allied';
import AltusInitiateProposalPage from './Altus';
import DDNJInitiateProposalPage from './DDNJ';

function renderInitiateProposalPage(sponsorId: string): React.ReactNode {
  switch (sponsorId) {
    case 'SUNLIFE':
      return <SunLifeInitiateProposalPage />;
    case 'DDIC':
      return <AlliedInitiateProposalPage />;
    case 'DDNJ':
      return <DDNJInitiateProposalPage />;
    case '244':
      return <AltusInitiateProposalPage />;
    default:
      return <DefaultInitiateProposalPage />;
  }
}

const InitiateProposalPage: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();
  const {
    domainStoreV2: { sponsorId },
  } = useRootStore();

  if (!groupId || !sponsorId) {
    return null;
  }

  return renderInitiateProposalPage(sponsorId);
});

export default InitiateProposalPage;
